export default __webpack_public_path__ + "c99c3eb3ccbdb1d697b8d519acc1b440.png";